/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Storytelling (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'dashboard-analytics/visualizations/renderer/filter/FilterLabelHelper',
	'./TimelineHighlightAction'
], function(_, FilterLabelHelper, TimelineHighlightAction) {

	class TimelineHighlightFlyoutController {

		constructor(options){
			this.highlightAct = options.highlightAct;
			this.launchView = options.launchView;
			this.launchPoint = options.launchPoint;
			this.backButtonCallback = options.show;
			this.dashboardApi = options.dashboardApi;
			this.pageContextAPI = options.pageContextAPI;
			this.services = options.services;
			this.logger = this.dashboardApi.getGlassCoreSvc('.Logger');
			this.stringResources = this.dashboardApi.getDashboardCoreSvc('.StringResources');
			this.content = options.content;
			this.visualization = options.visualization;
			this.filterLabelHelper = new FilterLabelHelper({
				dataSource: this.visualization.getDataSource(),
				'timelineFilter': 'timelineFilter',
				'filterLineEnabled': this._isFilterLineEnabled,
				'filterLineDeleteEnabled' : this._isFilterLineDeleteEnabled,
				dashboardApi: this.dashboardApi
			});
		}

		onEditTimelineFilter(event, dataId) {
			this.editTimelineFilter(dataId, event.currentTarget);
		}

		onRemoveTimelineFilter(event, dataId){
			event.stopPropagation();
			const matchingSlotDataItem = _.find(this.visualization.getSlots().getMappingInfoList(), mapping => {
				return mapping.dataItem.getColumnId() === dataId;
			});
			const slot = matchingSlotDataItem.slot;
			const index = matchingSlotDataItem.indexInSlot;
			const timelineHighlightAction = new TimelineHighlightAction(this.visualization, slot, index, this.pageContextAPI, this.services, this.logger, this.highlightAct);
			timelineHighlightAction.removeFilter(dataId);
		}

		getItemActions() {
			return this._generateFilterListItems(this.highlightAct.get('payload'));
		}

		_generateFilterListItems(timelineFilters) {

			const listItems = this.filterLabelHelper.generateFilterListItems(timelineFilters);

			listItems.forEach((item) => {
				item.editLabel =  this.stringResources.get('editTimelineHighlight');
				item.deleteLabel = this.stringResources.get('deleteTimelineHighlight');
				item.editAction = this.onEditTimelineFilter.bind(this);
				item.deleteAction = this.onRemoveTimelineFilter.bind(this);
			});

			return listItems;
		}

		editTimelineFilter(columnId, node) {
			if (!node) {
				return Promise.resolve();
			}
			const filterEntry = [_.findWhere(this.highlightAct.get('payload'), {
				columnId: columnId
			})];
			const matchingSlotDataItem = _.find(this.visualization.getSlots().getMappingInfoList(), mapping => {
				return mapping.dataItem.getColumnId() === columnId;
			});
			const slot = matchingSlotDataItem.slot;
			const dataItem = matchingSlotDataItem.dataItem;
			const index = matchingSlotDataItem.indexInSlot;
			const timelineHighlightAction = new TimelineHighlightAction(this.visualization, slot, index, this.pageContextAPI, this.services, this.logger, this.highlightAct);
			const dialogModule = timelineHighlightAction.getEditorModuleName();
			const viewOptions = {
				columnId: columnId,
				filterSpec: filterEntry,
				highlightAct: this.highlightAct,
				columnTitle: dataItem.getLabel(),
				title:  this.stringResources.get('timelineHighlightTitle'),
				slot: slot,
				dashboardApi: this.dashboardApi,
				pageContextAPI: this.pageContextAPI,
				services: this.services,
				itemContext: timelineHighlightAction.itemContext
			};
			const interactivityController = this.content.getFeature('InteractivityController.deprecated');
			return interactivityController
				.getActionHelper()
				.renderFilterDialog(dialogModule, viewOptions, this.launchPoint, this.launchView, this.backButtonCallback);
		}

		_isFilterLineDeleteEnabled(filter) {
			return Boolean(filter.values.length);
		}

		_isFilterLineEnabled(){
			return true;
		}
	}
	return TimelineHighlightFlyoutController;
});
